// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentTitleFragmentDoc } from './content/ContentTitle.fragment.generated';
import { ComponentTextFragmentDoc } from './content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from './content/ContentButton.fragment.generated';
import { ComponentSpacerFragmentDoc } from './content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from './content/ContentImage.fragment.generated';
import { ComponentOrderedListFragmentDoc } from './content/ContentOrderedList.fragment.generated';
export const ContentComponentItemFragmentDoc = gql`
    fragment contentComponentItem on ContentComponentItem {
  __typename
  ...componentTitle
  ...componentText
  ...componentButton
  ...componentSpacer
  ...componentImage
  ...componentOrderedList
}
    ${ComponentTitleFragmentDoc}
${ComponentTextFragmentDoc}
${ComponentButtonFragmentDoc}
${ComponentSpacerFragmentDoc}
${ComponentImageFragmentDoc}
${ComponentOrderedListFragmentDoc}`;